import { ConditionViewerItem } from '@customerio/pluma-components/react';
import type { AttributeNode } from '../../types';
import { getIconForNode } from '../data-source-icon';
import { FieldOperatorValue } from '../condition-parts';

type AttributeConditionProps = { node: AttributeNode };

export function AttributeCondition({ node }: AttributeConditionProps) {
  return (
    <ConditionViewerItem icon={getIconForNode(node)}>
      <FieldOperatorValue
        field={node.field}
        operator={node.operator}
        valueSource={node.valueSource}
        value={node.value}
        value2={node.value2}
      />
    </ConditionViewerItem>
  );
}
